import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Product Tabs
 */
@Component
export class ProductTabs extends ThemeComponent {
    @Ref tabTriggers!: HTMLButtonElement[];
    @Ref tabs!: HTMLDivElement[];
    @Ref floatingNavigation!: HTMLDivElement;
    @Ref tabNavigationTriggers!: HTMLAnchorElement[];

    protected activeTriggers: HTMLButtonElement[]|undefined|null = null;
    protected activeTab: HTMLDivElement|undefined|null = null;
    protected currentScrollTop: number = 0;

    protected floatingNavigationBounds: HeaderBounds = {
        top: 0,
        bottom: 0
    };

    init() {

        this.activeTriggers = this.tabTriggers.filter(
            (tabTrigger) => tabTrigger.classList.contains('active-trigger')
        );

        this.activeTab = this.tabs.find((tab) => tab.classList.contains('active-tab'));

        for (const tabTrigger of this.tabTriggers) {

            this.$listen(tabTrigger, 'click', (event) => {
                this.onTabClick(event);
            });
        }

        for (const tabNavigationTrigger of this.tabNavigationTriggers) {

            this.$listen(tabNavigationTrigger, 'click', (event) => {
                this.onTabNavigationClick(event);
            });
        }

        const outsideTriggers = document.querySelectorAll('[data-tab-links]') as NodeListOf<HTMLAnchorElement>;

        for (const outsideTrigger of outsideTriggers) {

            this.$listen(outsideTrigger, 'click', (event) => {
                this.onTabNavigationClick(event);
            });
        }

        window.addEventListener('scroll', this.onScroll.bind(this), false);

        this.createObserver();
    }

    protected createObserver() {

        const observer = new IntersectionObserver((entries, observer) => {
            this.floatingNavigationBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.floatingNavigation);
    }

    onTabNavigationClick(event: Event) {

        event.preventDefault();

        const clickedElement = event.currentTarget as HTMLAnchorElement;
        const goToSelector = clickedElement.getAttribute('href') as string;
        const destinationElement = document.querySelector(goToSelector) as HTMLDivElement;

        if (!destinationElement) {return;}

        if (clickedElement.dataset.nonTab != null){
            destinationElement.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
            return;
        }

        if (this.activeTab) {
            this.activeTab.classList.remove('active-tab');
            this.activeTab = destinationElement;
        }

        if (this.activeTriggers) {
            for (const activeTrigger of this.activeTriggers) {
                activeTrigger.classList.remove('active-trigger');
            }
            this.activeTriggers = null;
        }

        this.activeTriggers = this.tabTriggers.filter(
            (tabTrigger) => tabTrigger.dataset.id == destinationElement.dataset.id
        );

        if (!this.activeTriggers) {return;}

        for (const activeTrigger of this.activeTriggers) {
            activeTrigger.classList.add('active-trigger');
        }

        destinationElement.classList.add('active-tab');

        destinationElement.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    }

    onScroll() {

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 140) {
            this.floatingNavigation.classList.add('fixed-navigation');
        } else {
            this.floatingNavigation.classList.remove('fixed-navigation');
        }

        this.currentScrollTop = scrollTop;
    }

    onTabClick(event: Event) {

        const clickedElement = event.currentTarget as HTMLButtonElement;

        const tabId = clickedElement.dataset.id;

        const tabElement = this.tabs.find((tab) => tab.dataset.id === tabId);

        const clientWidth = document.body.clientWidth as number;

        if (!tabElement) {return;}

        if (this.activeTab === undefined) {return;}

        if (this.activeTab !== null && tabElement.dataset.id === this.activeTab.dataset.id && clientWidth < 1025){
            this.activeTab.classList.remove('active-tab');
            this.activeTab = null;
            if (this.activeTriggers) {
                for (const activeTrigger of this.activeTriggers) {
                    activeTrigger.classList.remove('active-trigger');
                }
                this.activeTriggers = null;
            }

        } else {

            if (this.activeTab) {
                this.activeTab.classList.remove('active-tab');
            }

            this.activeTab = tabElement;

            tabElement.classList.add('active-tab');

            if (this.activeTriggers) {
                for (const activeTrigger of this.activeTriggers) {
                    activeTrigger.classList.remove('active-trigger');
                }
                this.activeTriggers = null;
            }

            this.activeTriggers = this.tabTriggers.filter(
                (tabTrigger) => tabTrigger.dataset.id == clickedElement.dataset.id
            );

            if (!this.activeTriggers) {return;}

            for (const activeTrigger of this.activeTriggers) {
                activeTrigger.classList.add('active-trigger');
            }

            if (clientWidth < 1025) {
                clickedElement.scrollIntoView();
            }
        }
    }
}
